import MiniHeroSection from "../components/MiniHeroSection";
import ContentBelowHeroBanner from "../components/ContentBelowHeroBanner";
import ServicesPagePostSection from "../components/ServicesPagePostSection";
import PopupSection from "../components/PopupSection";
import { Helmet } from "react-helmet-async";
import useSWR from "swr";
import { useState } from "react";
import { secureFetcher, SECURITY_CONFIG } from "../config/security";
import ProductsAndServices from "../components/services/ProductAndServices";
import BuildWith from "../components/services/BuiltWith";

function Services() {
  const {
    data: ServicesData,
    error,
    isLoading,
  } = useSWR(
    `${SECURITY_CONFIG.API_BASE_URL}${SECURITY_CONFIG.WP_PAGES_ENDPOINT}/1205`,
    secureFetcher,
  );

  return (
    <>
      {ServicesData && (
        <Helmet>
          <title>{ServicesData?.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={ServicesData?.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={ServicesData?.yoast_head_json?.og_description}
          />
        </Helmet>
      )}
      <MiniHeroSection data={ServicesData?.acf?.hero_banner} />
      <ContentBelowHeroBanner
        data={ServicesData?.acf?.content_below_hero_banner}
      />
      <ProductsAndServices />
      <BuildWith content={ServicesData?.acf?.built_with} />
    </>
  );
}
export default Services;
